var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "title mt-5" }, [
      _c("h3", { staticClass: "d-flex justify-content-center header" }, [
        _vm._v("\n      " + _vm._s(_vm.$t("headers.hearing_test")) + "\n    ")
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "custom-container" }, [
      _c(
        "div",
        { staticClass: "form-wrapper" },
        [
          _c("div", { staticClass: "form row mx-md-5 pb-5 px-3 px-md-5" }, [
            _c("form", { staticClass: "col-12", attrs: { novalidate: "" } }, [
              _c("div", { staticClass: "d-flex justify-content-center" }, [
                _c("span", { staticClass: "header header-4" }, [
                  _vm._v(_vm._s(_vm.$t("headers.contact_info")))
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-row" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.data.name,
                        expression: "form.data.name"
                      }
                    ],
                    staticClass: "form-control",
                    class: { "is-invalid": _vm.errors.has("name") },
                    attrs: {
                      id: "name",
                      type: "text",
                      placeholder: _vm.$t("form.name"),
                      maxlength: "255"
                    },
                    domProps: { value: _vm.form.data.name },
                    on: {
                      focus: function($event) {
                        return _vm.errors.clear("name")
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.form.data, "name", $event.target.value)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("name"),
                          expression: "errors.has('name')"
                        }
                      ],
                      staticClass: "invalid-feedback"
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.errors.get("name")) +
                          "\n              "
                      )
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-row" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.data.phone,
                        expression: "form.data.phone"
                      }
                    ],
                    staticClass: "form-control",
                    class: { "is-invalid": _vm.errors.has("phone") },
                    attrs: {
                      id: "phone",
                      type: "text",
                      placeholder: _vm.$t("form.placeholders.phone"),
                      maxlength: "16"
                    },
                    domProps: { value: _vm.form.data.phone },
                    on: {
                      focus: function($event) {
                        return _vm.errors.clear("phone")
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.form.data, "phone", $event.target.value)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("phone"),
                          expression: "errors.has('phone')"
                        }
                      ],
                      staticClass: "invalid-feedback"
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.errors.get("phone")) +
                          "\n              "
                      )
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-row" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.data.email,
                        expression: "form.data.email"
                      }
                    ],
                    staticClass: "form-control",
                    class: { "is-invalid": _vm.errors.has("email") },
                    attrs: {
                      id: "email",
                      type: "text",
                      placeholder: _vm.$t("form.email"),
                      maxlength: "255"
                    },
                    domProps: { value: _vm.form.data.email },
                    on: {
                      focus: function($event) {
                        return _vm.errors.clear("email")
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.form.data, "email", $event.target.value)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("email"),
                          expression: "errors.has('email')"
                        }
                      ],
                      staticClass: "invalid-feedback"
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.errors.get("email")) +
                          "\n              "
                      )
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _vm.$i18n.locale !== "pt" && !_vm.form.data.contact_request
                ? _c("div", { staticClass: "form-row" }, [
                    _c("div", { staticClass: "col-12" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.data.city,
                            expression: "form.data.city"
                          }
                        ],
                        staticClass: "form-control",
                        class: { "is-invalid": _vm.errors.has("city") },
                        attrs: {
                          id: "city",
                          type: "text",
                          placeholder: _vm.$t("form.city"),
                          maxlength: "255"
                        },
                        domProps: { value: _vm.form.data.city },
                        on: {
                          focus: function($event) {
                            return _vm.errors.clear("city")
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(_vm.form.data, "city", $event.target.value)
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.errors.has("city"),
                              expression: "errors.has('city')"
                            }
                          ],
                          staticClass: "invalid-feedback"
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.errors.get("city")) +
                              "\n              "
                          )
                        ]
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.$i18n.locale === "pt"
                ? _c("div", { staticClass: "form-row" }, [
                    _c("div", { staticClass: "col-12 col-md-6" }, [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.distrito,
                              expression: "distrito"
                            }
                          ],
                          staticClass: "form-control",
                          class: { "is-invalid": _vm.errors.has("distrito") },
                          attrs: { required: "" },
                          on: {
                            change: [
                              function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.distrito = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              },
                              _vm.onChangeDistrito
                            ],
                            focus: function($event) {
                              return _vm.errors.clear("distrito")
                            }
                          }
                        },
                        [
                          _c(
                            "option",
                            {
                              attrs: { disabled: "", selected: "" },
                              domProps: { value: null }
                            },
                            [_vm._v("Distrito")]
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.distritoOptions, function(item, index) {
                            return _c("option", [_vm._v(_vm._s(index))])
                          })
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "invalid-feedback" }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.errors.get("distrito")) +
                            "\n              "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-12 col-md-6" }, [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.concelho,
                              expression: "concelho"
                            }
                          ],
                          staticClass: "form-control",
                          class: { "is-invalid": _vm.errors.has("concelho") },
                          attrs: {
                            disabled: _vm.distrito == null,
                            required: ""
                          },
                          on: {
                            focus: function($event) {
                              return _vm.errors.clear("concelho")
                            },
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.concelho = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            }
                          }
                        },
                        [
                          _c(
                            "option",
                            {
                              attrs: { disabled: "", selected: "" },
                              domProps: { value: null }
                            },
                            [_vm._v("Concelho")]
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.distritoOptions[_vm.distrito], function(
                            item,
                            index
                          ) {
                            return _c("option", [_vm._v(_vm._s(item))])
                          })
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "invalid-feedback" }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.errors.get("concelho")) +
                            "\n              "
                        )
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "form-row" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c("div", { staticClass: "checkbox__container" }, [
                    _vm.form.data.contact_request
                      ? _c("span", {
                          staticClass: "i-checkbox-selected",
                          on: {
                            click: function($event) {
                              _vm.form.data.contact_request = false
                            }
                          }
                        })
                      : _c("span", {
                          staticClass: "i-checkbox",
                          on: {
                            click: function($event) {
                              _vm.form.data.contact_request = true
                            }
                          }
                        }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "checkbox__label",
                        attrs: { for: "checkbox-contact-request" }
                      },
                      [_vm._v(_vm._s(_vm.$t("form.contact_request")))]
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _vm.form.data.contact_request
                ? _c("div", { staticClass: "form-row" }, [
                    _c("div", { staticClass: "col-12" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.data.address_line_1,
                            expression: "form.data.address_line_1"
                          }
                        ],
                        staticClass: "form-control",
                        class: {
                          "is-invalid": _vm.errors.has("address_line_1")
                        },
                        attrs: {
                          id: "address_line_1",
                          type: "text",
                          placeholder: _vm.$t("form.address"),
                          maxlength: "255"
                        },
                        domProps: { value: _vm.form.data.address_line_1 },
                        on: {
                          focus: function($event) {
                            return _vm.errors.clear("address_line_1")
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.form.data,
                              "address_line_1",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.errors.has("address_line_1"),
                              expression: "errors.has('address_line_1')"
                            }
                          ],
                          staticClass: "invalid-feedback"
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.errors.get("address_line_1")) +
                              "\n              "
                          )
                        ]
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.form.data.contact_request
                ? _c("div", { staticClass: "form-row mb-5" }, [
                    _c("div", { staticClass: "col-12 col-md-6" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.data.address_postal_code,
                            expression: "form.data.address_postal_code"
                          }
                        ],
                        staticClass: "form-control",
                        class: {
                          "is-invalid": _vm.errors.has("address_postal_code")
                        },
                        attrs: {
                          id: "address_postal_code",
                          type: "text",
                          placeholder: _vm.$t("form.postal_code"),
                          maxlength: "255"
                        },
                        domProps: { value: _vm.form.data.address_postal_code },
                        on: {
                          focus: function($event) {
                            return _vm.errors.clear("address_postal_code")
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.form.data,
                              "address_postal_code",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.errors.has("address_postal_code"),
                              expression: "errors.has('address_postal_code')"
                            }
                          ],
                          staticClass: "invalid-feedback"
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.errors.get("address_postal_code")) +
                              "\n              "
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-12 col-md-6" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.data.address_city,
                            expression: "form.data.address_city"
                          }
                        ],
                        staticClass: "form-control",
                        class: { "is-invalid": _vm.errors.has("address_city") },
                        attrs: {
                          id: "address_city",
                          type: "text",
                          placeholder: _vm.$t("form.city"),
                          maxlength: "255"
                        },
                        domProps: { value: _vm.form.data.address_city },
                        on: {
                          focus: function($event) {
                            return _vm.errors.clear("address_city")
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.form.data,
                              "address_city",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.errors.has("address_city"),
                              expression: "errors.has('address_city')"
                            }
                          ],
                          staticClass: "invalid-feedback"
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.errors.get("address_city")) +
                              "\n              "
                          )
                        ]
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "form-row" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c("div", { staticClass: "checkbox__container" }, [
                    _vm.userAgreesToPrivacyPolicy
                      ? _c("span", {
                          staticClass: "i-checkbox-selected",
                          on: {
                            click: function($event) {
                              _vm.userAgreesToPrivacyPolicy = false
                            }
                          }
                        })
                      : _c("span", {
                          staticClass: "i-checkbox",
                          on: {
                            click: function($event) {
                              _vm.userAgreesToPrivacyPolicy = true
                            }
                          }
                        }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "checkbox__label",
                        attrs: { for: "checkbox-privacy-policy" }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t("results.accept_passing_data_to_partners")
                          )
                        )
                      ]
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-row" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c("div", { staticClass: "checkbox__container" }, [
                    _vm.form.data.marketing
                      ? _c("span", {
                          staticClass: "i-checkbox-selected",
                          on: {
                            click: function($event) {
                              _vm.form.data.marketing = false
                            }
                          }
                        })
                      : _c("span", {
                          staticClass: "i-checkbox",
                          on: {
                            click: function($event) {
                              _vm.form.data.marketing = true
                            }
                          }
                        }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "checkbox__label",
                        attrs: { for: "checkbox-marketing" }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("results.accept_marketing_purposes"))
                        )
                      ]
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-row" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c(
                    "span",
                    {
                      staticClass: "span-link",
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.showModal($event)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("results.see_privacy_policy")))]
                  )
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "modal",
            {
              staticClass: "modal__container",
              attrs: {
                name: "dialog",
                width: _vm.modalWidth,
                height: "auto",
                delay: 50,
                scrollable: "",
                adaptive: "",
                transition: "fade-in"
              }
            },
            [
              _c("div", { staticStyle: { "min-height": "50vh" } }, [
                _c("iframe", {
                  staticStyle: {
                    width: "100%",
                    height: "100%",
                    position: "absolute"
                  },
                  attrs: {
                    src:
                      _vm.$i18n.locale === "en"
                        ? "https://evollu.com/legal/hearing-test/en/privacy_notice.html"
                        : "https://evollu.com/legal/hearing-test/pt/privacy_notice.html",
                    frameborder: "0"
                  }
                })
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "actions d-flex justify-content-center mb-3" },
            [
              _c(
                "button",
                {
                  staticClass: "button primary",
                  class: {
                    disabled: _vm.isSubmiting || !_vm.userAgreesToPrivacyPolicy
                  },
                  staticStyle: { "white-space": "normal" },
                  attrs: {
                    type: "button",
                    disabled: _vm.isSubmiting || !_vm.userAgreesToPrivacyPolicy
                  },
                  on: { click: _vm.submit }
                },
                [_vm._v(_vm._s(_vm.$t("actions.receive_result")))]
              )
            ]
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }